<template>
    <scheme-business-verification-tabs />
    <router-view />
</template>

<script>
import SchemeBusinessVerificationTabs from './SchemeBusinessVerificationTabs.vue';

export default {
    name: 'SchemeBusinessVerificationRouter',
    components: {
        SchemeBusinessVerificationTabs
    }
};
</script>
